package com.gloopgo.game.audio

/**
 * Kotlin/JS Web implementation of SoundManager using the Web Audio API.
 */
class JsSoundManager : SoundManager {
    override var isSoundEnabled: Boolean = true

    override fun playPelletEatenSound() {
        if (!isSoundEnabled) return
        try {
            js("""
                if (typeof window !== 'undefined') {
                    var AudioCtx = window.AudioContext || window.webkitAudioContext;
                    if (AudioCtx) {
                        if (!window.__gloopAudioCtx) {
                            window.__gloopAudioCtx = new AudioCtx();
                        }
                        var ctx = window.__gloopAudioCtx;
                        if (ctx.state === 'suspended') {
                            ctx.resume();
                        }
                        var now = ctx.currentTime;
                        var osc = ctx.createOscillator();
                        var gain = ctx.createGain();
                        osc.type = 'sine';
                        osc.frequency.setValueAtTime(600, now);
                        osc.frequency.exponentialRampToValueAtTime(1300, now + 0.06);
                        gain.gain.setValueAtTime(0.2, now);
                        gain.gain.exponentialRampToValueAtTime(0.001, now + 0.06);
                        osc.connect(gain);
                        gain.connect(ctx.destination);
                        osc.start(now);
                        osc.stop(now + 0.06);
                    }
                }
            """)
        } catch (_: Throwable) {}
    }

    override fun playGameEntrySound() {
        if (!isSoundEnabled) return
        try {
            js("""
                if (typeof window !== 'undefined') {
                    var AudioCtx = window.AudioContext || window.webkitAudioContext;
                    if (AudioCtx) {
                        if (!window.__gloopAudioCtx) {
                            window.__gloopAudioCtx = new AudioCtx();
                        }
                        var ctx = window.__gloopAudioCtx;
                        if (ctx.state === 'suspended') {
                            ctx.resume();
                        }
                        var now = ctx.currentTime;
                        var notes = [523.25, 659.25, 783.99, 1046.50];
                        notes.forEach(function(freq, idx) {
                            var startTime = now + idx * 0.075;
                            var osc = ctx.createOscillator();
                            var gain = ctx.createGain();
                            osc.type = 'sine';
                            osc.frequency.value = freq;
                            gain.gain.setValueAtTime(0.22, startTime);
                            gain.gain.exponentialRampToValueAtTime(0.001, startTime + (idx === 3 ? 0.22 : 0.09));
                            osc.connect(gain);
                            gain.connect(ctx.destination);
                            osc.start(startTime);
                            osc.stop(startTime + (idx === 3 ? 0.22 : 0.09));
                        });
                    }
                }
            """)
        } catch (_: Throwable) {}
    }

    override fun playHazardEatenSound() {
        if (!isSoundEnabled) return
        try {
            js("""
                if (typeof window !== 'undefined') {
                    var AudioCtx = window.AudioContext || window.webkitAudioContext;
                    if (AudioCtx) {
                        if (!window.__gloopAudioCtx) {
                            window.__gloopAudioCtx = new AudioCtx();
                        }
                        var ctx = window.__gloopAudioCtx;
                        if (ctx.state === 'suspended') {
                            ctx.resume();
                        }
                        var now = ctx.currentTime;
                        var osc1 = ctx.createOscillator();
                        var osc2 = ctx.createOscillator();
                        var gain = ctx.createGain();

                        osc1.type = 'sawtooth';
                        osc1.frequency.setValueAtTime(260, now);
                        osc1.frequency.exponentialRampToValueAtTime(65, now + 0.18);

                        osc2.type = 'sine';
                        osc2.frequency.setValueAtTime(368, now);
                        osc2.frequency.exponentialRampToValueAtTime(92, now + 0.18);

                        gain.gain.setValueAtTime(0.3, now);
                        gain.gain.exponentialRampToValueAtTime(0.001, now + 0.18);

                        osc1.connect(gain);
                        osc2.connect(gain);
                        gain.connect(ctx.destination);

                        osc1.start(now);
                        osc2.start(now);
                        osc1.stop(now + 0.18);
                        osc2.stop(now + 0.18);
                    }
                }
            """)
        } catch (_: Throwable) {}
    }
}

actual fun getSoundManager(): SoundManager = JsSoundManagerInstance
private val JsSoundManagerInstance by lazy { JsSoundManager() }
